var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBuildingIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 62.599 62",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".building_icon_svg__a{fill:none;stroke:inherit;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-svg-primary": "stroke"
  }, /*#__PURE__*/React.createElement("path", {
    className: "building_icon_svg__a",
    d: "M45.381 25.612v35.39h16.218v-40.79H49.856M41.729 9.969h3.651V61H17.218V9.969h3.651M50.893 32.346h5.193M24.189 21.759h3.171M24.189 27.135h3.171M24.189 32.506h3.171M24.189 37.876h3.171M24.189 43.247h3.171M35.238 21.759h3.171M35.238 27.135h3.171M35.238 32.506h3.171M35.238 37.876h3.171M35.238 43.247h3.171M50.893 38.35h5.193M50.893 32.506h5.193M50.893 26.661h5.193M50.893 44.349h5.193M50.893 50.354h5.193M17.218 25.612V61H1V28.74l11.595-7.42M11.706 32.346H6.513M11.706 38.35H6.513M11.706 44.349H6.513M11.706 50.354H6.513"
  }), /*#__PURE__*/React.createElement("path", {
    className: "building_icon_svg__a",
    d: "M35.558 57.195V50.04H27.04v7.155M31.302 5.055V1M24.936 5.647h12.727v4.321H24.936zM53.49 20.212v-2.964"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBuildingIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/building_icon.73f98369dddf16f70bbd71f42e45813a.svg";